import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Destroyer } from 'src/app/core/abstract/destroyer';
import { StringTMap } from 'src/app/core/models/common.models';
import { WorkflowStatus } from 'src/app/core/models/workflow-statuses.models';
import { WorkflowStatusesStoreService } from 'src/app/core/store/services/workflow-statuses-store.service';

@Component({
  selector: 'craft-workflow-status-label',
  templateUrl: './craft-workflow-status-label.component.html',
  styleUrls: ['./craft-workflow-status-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CraftWorkflowStatusLabelComponent extends Destroyer implements OnInit {
  @Input() public selectedId: string | undefined;
  public ws: Readonly<StringTMap<WorkflowStatus>>;

  constructor(
    private cdr: ChangeDetectorRef, //
    private wsStore: WorkflowStatusesStoreService,
  ) {
    super();
  }

  public get name() {
    if (!this.selectedId) return '';
    return this.ws[this.selectedId]?.name || '';
  }

  public get bgcolor() {
    if (!this.selectedId) return '';
    return this.ws[this.selectedId]?.color || '';
  }

  public ngOnInit() {
    this.wsStore.map$.pipe(takeUntil(this.destroy$)).subscribe((statuses) => {
      this.ws = statuses;
      this.cdr.detectChanges();
    });
  }
}
